import React from "react";
import {
  RiTimeLine,
  RiWeightLine,
  RiListCheck3,
  RiBarChartGroupedLine,
  RiFireLine,
  RiTrophyLine,
} from "react-icons/ri";
import { formatDuration, formatNumber } from "../../utils/helpers";

const PostStatsRow = ({ stats }) => {
  const items = [
    { icon: RiTimeLine, value: formatDuration(stats.durationMin) },
    { icon: RiWeightLine, value: `${formatNumber(stats.volumeKg)} kg` },
    { icon: RiListCheck3, value: `${stats.exerciseCount} Exercises` },
    { icon: RiBarChartGroupedLine, value: `${stats.setCount} Sets` },
    { icon: RiFireLine, value: `${stats.calories} Cal` },
  ];
  if (stats.prCount > 0) {
    items.push({
      icon: RiTrophyLine,
      value: `${stats.prCount} New PR${stats.prCount > 1 ? "s" : ""}`,
      accent: true,
    });
  }

  return (
    <div className="wpc-stats">
      {items.map(({ icon: Icon, value, accent }, i) => (
        <span className={`wpc-stat ${accent ? "wpc-stat--accent" : ""}`} key={i}>
          <Icon size={14} />
          {value}
        </span>
      ))}
    </div>
  );
};

export default PostStatsRow;
